export default "__VITE_ASSET__c899baab__"